import React from 'react';

import AppRouter from 'routers/AppRouter/AppRouter';
import { store } from 'store';
import { Provider } from 'react-redux';
import { AuthProvider } from 'context/AuthProvider';
import { ToastContainer } from 'react-toastify';
import 'styles/App.css';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmModal from 'components/shared/ConfirmDeleteModal';

const App = () => (
  <Provider store={store}>
    <AuthProvider>
      <AppRouter />
      <ToastContainer />
      <ConfirmModal />
    </AuthProvider>
  </Provider>
);
export default App;